{
  "accountLockedMessage": "Your farm's account has been locked due to non-payment of subscription fees. To restore access, contact FarmHQ to arrange payment.",
  "accountLockedTitle": "Account Locked",
  "dueDatePassedMessagewithLockDate": "Your farm's subscription is past due. Your account will be locked on {{lockDate, datetime}}.",
  "dueDatePassedTitle": "Subscription Payment Late",
  "dueDateUpcomingMessageWithDueDate": "Your farm's subscription renewal payment is due on {{dueDate, datetime}}. If payment is not received, your account may be locked.",
  "dueDateUpcomingTitle": "Reminder: Subscription Renewal Due Date Upcoming",
  "dueDateWithValue": "Subscription Renewal Due Date: {{value, datetime}}",
  "eitherPayOrContactUs": "You have received an invoice at your main account email address. To arrange payment, or if you have questions, contact FarmHQ."
}
